export default __webpack_public_path__ + "static/media/ethereum.97d74e36.svg";